import { Spacing, SpacingName, Typography } from '@doveit/lego';
import React, { FunctionComponent } from 'react';
import AgentCard, { AgentCardProps } from '../../../components/agent-card/AgentCard';
import * as styles from './IntentBox.style';

export interface IntentBoxProps {
  title?: string,
  subtitle?: string,
  reference: string,
  agent?: AgentCardProps,
  minimal?: boolean,
  children: JSX.Element,
}

export const INTENT_BOX_TITLE = 'Ti piace questo immobile?';
export const INTENT_BOX_SUBTITLE = 'Il nostro esperto è a tua disposizione.';

const IntentBox: FunctionComponent<IntentBoxProps> = ({
  title = INTENT_BOX_TITLE,
  subtitle = INTENT_BOX_SUBTITLE,
  reference,
  agent,
  minimal,
  children,
}) => (
  <div data-ref="intent-box">
    <div
      css={styles.wrapper}
      $minimal={minimal}
    >
      {!minimal && (
        <header
          css={styles.header}
          data-ref="intent-box-header"
        >
          <h3
            css={styles.title}
            data-ref="intent-box-title"
          >
            {title}
          </h3>
        </header>
      )}

      <div
        css={styles.content}
        $minimal={minimal}
      >
        <Typography.BODY tagName="div">
          {subtitle}
        </Typography.BODY>

        <Spacing padding={[SpacingName.SMALL, 0, 0]}>
          {children}
        </Spacing>
      </div>
    </div>

    <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
      <div css={styles.reference}>
        Rif. immobile <strong>{reference}</strong>
      </div>

      {agent && (
        <Spacing margin={[SpacingName.SMALLER, 0, 0]}>
          <AgentCard
            name={agent.name}
            jobTitle={agent.jobTitle}
            picture={agent.picture}
            urlObject={agent.urlObject}
            franchising={agent.franchising}
          />
        </Spacing>
      )}
    </Spacing>
  </div>
);

export default IntentBox;
